import def from "csi/def";
import html from "csi/html";
import PropertyWidget from "csi/property/Widget";
import declare from "dojo/_base/declare";
import { isPresentationEditor } from "./PPService";

const SetProperties = declare(PropertyWidget, {
	/**
	 * Extension point for edit set button
	 */
	onEditSet() { },

	/**
	 * @override
	 * Add action to edit the set
	 */
	onViewCreate() {
		if (isPresentationEditor()) {
			const action = this.defView._addViewAction("PPEditSet", {
				m_class: html.CSS_BUTTON_PRIMARY,
				m_onAction: "onEditSet",
				m_typeControl: def.ACTION_BUTTON,
			});

			this.plugins.unshift("|");
			this.plugins.unshift(action);
		}
	},
});

export = SetProperties;
